<template>
  <div class="content asset-depreciation-list">
    <section style="margin-bottom: 1%">
      <!-- <a-button type="primary" @click="createHandle">
        <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
        {{ $t('新增资产折旧单') }}
      </a-button> -->
      <a-button type="primary" style="margin-right: 10px" @click="openGenerateModal">
        <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
        {{ $t('生成资产折旧单') }}
      </a-button>
    </section>
    <div class="form-content">
      <a-row :gutter="16" style="margin-top: 15px">
        <a-col :span="6">
          <CommonSelect
            :isBu="true"
            mode="multiple"
            :placeholder="$t('结算组织')"
            :list="$store.state.settlementBuList"
            :code.sync="formData.ownerBusinessUnitCodeList"
            @change="searchHandle(1)"
          />
        </a-col>
        <a-col :span="6">
          <a-input
            allow-clear
            v-model.trim="formData.depreciationNo"
            :placeholder="$t('请输入单据编号')"
          />
        </a-col>
        <a-col :span="6">
          <a-select
            v-model="formData.needGenerateVoucher"
            allow-clear
            :placeholder="$t('能否生成凭证')"
            style="width: 100%"
          >
            <a-select-option :value="1">{{ $t('需要') }}</a-select-option>
            <a-select-option :value="0">{{ $t('不需要') }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6">
          <a-select
            v-model="formData.voucherGenerated"
            allow-clear
            :placeholder="$t('已生成凭证')"
            style="width: 100%"
          >
            <a-select-option :value="1">{{ $t('是') }}</a-select-option>
            <a-select-option :value="0">{{ $t('否') }}</a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row :gutter="16" class="mt10">
        <a-col :span="6">
          <a-button @click="searchHandle(1)" type="primary">
            <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
            {{ $t(`查询`) }}
          </a-button>
          <a-button @click="reset">
            <a-icon type="redo" />
            {{ $t(`重置`) }}
          </a-button>
        </a-col>
      </a-row>
    </div>
    <CommonTable
      ref="CommonTableRef"
      :statusList="asset_operate_status"
      :columns.sync="columns"
      :loading="loading"
      :dataSource="tableData"
      :showSelect="true"
      :scroll="{ x: 1500 }"
      :selectedRowKeys.sync="selectedRowKeys"
      :selectedRows.sync="selectedRows"
      :total="total"
      rowKey="id"
      @select="onSelectChange"
      @search="getList"
    >
      <template v-slot:header>
        <div class="flex-ct">
          <OperateBtn
            api="operateAssetDepreciation"
            :text="$t('审核')"
            :params="{
              action: 'CHECK',
              idList: selectedRowKeys,
            }"
            :disabled="selectedRows.length === 0"
            @success="searchHandle"
          />
          <VoucherBtn
            class="ml10"
            :docType="docType"
            :selectedRows="selectedRows"
            :disabled="selectedRows.length === 0"
            @close="searchHandle"
          />
        </div>
      </template>
      <template v-slot:depreciationNo="{ text, record }">
        <a @click="viewDetail(record)">{{ text }}</a>
      </template>
      <template v-slot:totalDepreciationAmount="{ text }">
        <PriceInput :value="text" :showTxt="true" />
      </template>
    </CommonTable>

    <a-modal
      v-model="generateVisible"
      :title="$t('生成资产折旧单')"
      :width="480"
      :confirmLoading="generateLoading"
      destroyOnClose
      @ok="handleGenerate"
    >
      <a-form-model
        :model="generateForm"
        :rules="generateRules"
        ref="generateFormRef"
        layout="vertical"
      >
        <a-form-model-item :label="$t('结算组织')" prop="businessUnitCode">
          <CommonSelect
            :isBu="true"
            :list="$store.state.settlementBuList"
            :placeholder="$t('请选择结算组织')"
            :code.sync="generateForm.businessUnitCode"
            :name.sync="generateForm.businessUnitName"
            @change="handleGenerateBuChange"
          />
        </a-form-model-item>
        <a-form-model-item :label="$t('折旧期间')" prop="depreciationPeriod">
          <CommonQuerySelect
            api="queryAccountingCalendarDetailPage"
            valueName="accounting_period_code"
            labelName="accounting_period_name"
            :code.sync="generateForm.depreciationPeriod"
            :placeholder="$t('请选择折旧期间')"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import CommonTable from '@/component/commonTable'
import { convertKeysToCamelCase } from '@/common'
import { message } from 'ant-design-vue'
export default {
  name: 'AssetDepreciationList',
  components: { CommonTable },
  data() {
    return {
      docType: 'AssetDepreciation',
      formData: {
        needGenerateVoucher: undefined,
        voucherGenerated: undefined,
      },
      tableData: [],
      selectedRowKeys: [],
      selectedRows: [],
      total: 0,
      loading: false,

      generateVisible: false,
      generateLoading: false,
      generateForm: {
        businessUnitCode: undefined,
        businessUnitName: undefined,
        depreciationPeriod: undefined,
      },

      columns: [
        {
          title: this.$t('单据编号'),
          dataIndex: 'depreciationNo',
          width: 200,
          scopedSlots: { customRender: 'depreciationNo' },
        },
        {
          title: this.$t('结算组织'),
          dataIndex: 'ownerBusinessUnitName',
        },
        {
          title: this.$t('会计政策'),
          dataIndex: 'accountingPolicyName',
        },
        {
          title: this.$t('折旧期间'),
          dataIndex: 'accountingPeriodName',
        },
        {
          title: this.$t('本期折旧总额'),
          dataIndex: 'totalDepreciationAmount',
          scopedSlots: { customRender: 'totalDepreciationAmount' },
        },
        {
          title: this.$t('单据状态'),
          dataIndex: 'orderStatus',
          customRender: (text) => this.assetOperateStatusMapping[text],
        },
        {
          title: this.$t('能否生成凭证'),
          dataIndex: 'needGenerateVoucher',
          width: 100,
          customRender: (text, record) => {
            const val = record.needGenerateVoucher ?? record.need_generate_voucher
            return val === 1 ? this.$t('需要') : val === 0 ? this.$t('不需要') : ''
          },
        },
        {
          title: this.$t('是否生成凭证'),
          dataIndex: 'voucherGenerated',
          width: 100,
          customRender: (text) => (text ? this.$t('是') : this.$t('否')),
        },
        {
          title: this.$t('凭证号'),
          dataIndex: 'voucherNo',
          width: 100,
        },
      ],
    }
  },
  activated() {
    this.searchHandle()
  },
  computed: {
    ...mapState(['asset_operate_status']),
    ...mapGetters(['assetOperateStatusMapping']),
    generateRules() {
      return {
        businessUnitCode: [
          { required: true, message: this.$t('请选择结算组织'), trigger: 'change' },
        ],
        depreciationPeriod: [
          { required: true, message: this.$t('请选择折旧期间'), trigger: 'change' },
        ],
      }
    },
  },
  methods: {
    ...mapMutations(['addPane']),
    openGenerateModal() {
      this.generateForm = {
        businessUnitCode: undefined,
        businessUnitName: undefined,
        depreciationPeriod: undefined,
      }
      this.generateVisible = true
      this.$nextTick(() => {
        this.$refs.generateFormRef?.clearValidate()
      })
    },
    handleGenerateBuChange(item) {
      if (item && item.code) {
        this.getGenerateCurrentPeriod(item.code)
      } else {
        this.generateForm.depreciationPeriod = undefined
      }
    },
    async getGenerateCurrentPeriod(buCode) {
      try {
        await http({
          url: api.getCurrentAccountingPeriod,
          data: { ownerBusinessUnitCode: buCode },
          success: (res) => {
            if (res.result) {
              this.generateForm.depreciationPeriod = res.result.accounting_period_code
            }
          },
        })
      } catch (err) {
        // 接口异常已统一提示
      }
    },
    handleGenerate() {
      this.$refs.generateFormRef.validate(async (valid) => {
        if (!valid) return
        this.generateLoading = true
        try {
          await http({
            url: api.createAssetDepreciation,
            data: {
              businessUnitCode: this.generateForm.businessUnitCode,
              depreciationPeriod: this.generateForm.depreciationPeriod,
            },
            success: () => {
              message.success(this.$t('生成成功'))
              this.generateVisible = false
              this.searchHandle()
            },
          })
        } catch (err) {
          // 接口异常已统一提示
        } finally {
          this.generateLoading = false
        }
      })
    },
    reset() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.searchHandle(1)
    },
    searchHandle(pageNo) {
      if (this.formData.ownerBusinessUnitCodeList?.length === 0)
        return message.warning(this.$t('请选择结算组织'))
      this.selectedRows = []
      this.selectedRowKeys = []
      this.$refs.CommonTableRef.queryList(pageNo)
    },
    createHandle() {
      this.$router.push({ name: 'assetDepreciationDetail' })
    },
    async getList(params) {
      this.loading = true
      await http({
        url: api.getAssetDepreciationList,
        data: {
          ...this.formData,
          ...params,
        },
        success: (res) => {
          let result = convertKeysToCamelCase(res.result)
          this.tableData = result.list
          this.total = res.result.total
        },
      })
      this.loading = false
    },
    viewDetail(record) {
      this.addPane({
        view: 'asset/assetDepreciationDetail/' + record.depreciationNo,
        name: 'detailSn',
        query: {
          id: record.id,
          sn: record.depreciationNo,
        },
        route: `/asset/assetDepreciationDetail?id=${record.id}&sn=${record.depreciationNo}`,
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
  },
}
</script>
